import React from 'react';
import { ACCESS_TOKEN } from '../constants';
import { Navigate, useLocation } from 'react-router-dom'

const OAuth2RedirectHandler = ({ setIsTeacher }) => {
    const location = useLocation();

    const getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    setIsTeacher(getUrlParameter('result') == 'allowed');
    return (<Navigate replace to={{
        pathname: "/",
        state: { from: location }
    }} />);
}

export default OAuth2RedirectHandler;